import React from 'react';
import PropTypes from 'prop-types';
import { useLocation, useSearchParams } from 'react-router-dom';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { capitalize } from 'lodash';

import { popup, updatePlatform } from '../../../utils';
import { SUCCESS, MODAL, QUERY_KEYS } from '../../../constants';
import { GradeSelectModal } from '../../shared';
import InputWithSearch from '../../shared/common/InputWithSearch';

const ScoreCardAdminHeader = ({
    accountUserDetails,
    searchFn,
    searchValue,
    isOpenGradeSelectModal,
    setOpenGradeSelectModal,
    setSearchValue,
}) => {
    const queryClient = useQueryClient();
    const [searchParams, setSearchParams] = useSearchParams();
    const location = useLocation();

    const updatePtGradeMutation = useMutation({
        mutationFn: async (data) =>
            await updatePlatform({
                id: accountUserDetails?.platform_id.toString(),
                data,
            }),
        onSuccess: () => {
            queryClient.invalidateQueries({
                queryKey: [QUERY_KEYS.SCORECARD_DETAILS],
                exact: false,
            });
            queryClient.invalidateQueries({
                queryKey: [QUERY_KEYS.SCORECARD_LIST],
                exact: false,
            });
            popup('success', SUCCESS.SCORE_CARD_COLUMNS_ADMIN.GRADE_UPDATED);
            setOpenGradeSelectModal(false);
        },
        onError: (error) => {
            popup('error', error?.message || 'Something went wrong, while updating platform grade');
        },
    });

    const handleGradeSelect = (item) => {
        const data = { platform_grade: item, account_id: accountUserDetails?.id };
        updatePtGradeMutation.mutate(data);
    };

    return (
        <>
            {isOpenGradeSelectModal && (
                <GradeSelectModal
                    isGradeChangeModal={isOpenGradeSelectModal}
                    platform=''
                    handleUpdateClick={handleGradeSelect}
                    setGradeChangeConfirmationModalVisibility={setOpenGradeSelectModal}
                    heading={MODAL.SELECT_GRADE}
                    isLoading={updatePtGradeMutation.isPending}
                />
            )}
            <div className='ssc-scorecard-box'>
                <div className='p-2 name-box-set'>
                    <div className='d-flex flex-wrap gap-2 align-items-center justify-content-between'>
                        <div className='d-flex align-items-center justify-content-start w-50'>
                            <InputWithSearch
                                search={searchValue}
                                onClear={() => {
                                    const newParams = new URLSearchParams(searchParams);
                                    newParams.delete('search');
                                    setSearchParams(newParams, {
                                        replace: true,
                                        state: location.state,
                                    });
                                    setSearchValue('');
                                }}
                                onChange={searchFn}
                                placeholder='Search for Hiring Client'
                            />
                        </div>
                        <div className='upper-user-text mb-0 d-flex align-items-center justify-content-between gap-3'>
                            <span
                                className={`grade-circle ms-0 ${accountUserDetails.grade || 'grey'}-circle`}
                                title={
                                    'Platform Grade: ' +
                                    capitalize(accountUserDetails.grade || 'grey')
                                }
                            ></span>
                            <p className='font-16px mb-0'>{accountUserDetails?.name}</p>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default ScoreCardAdminHeader;

ScoreCardAdminHeader.propTypes = {
    accountUserDetails: PropTypes.object,
    searchFn: PropTypes.func,
    searchValue: PropTypes.string,
    isOpenGradeSelectModal: PropTypes.bool,
    setOpenGradeSelectModal: PropTypes.func,
};
